import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import {forwardRef, useImperativeHandle} from 'react'
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import {useTranslation} from "react-i18next";
import Select from '@mui/material/Select';
import styled from "styled-components";
import Grid from '@mui/material/Grid';
import {stateList} from './Lists.js';
import {observer} from 'mobx-react';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {stateIsValid} from './Util.js';

function is_woodpecker(spec) {
	/* TODO: add state mask in taxons */
// 	console.log('is_woodpecker', spec, 'Implement me!');
	return spec.woodpecker;
};

function is_breeding(spec) {
// 	console.log('is_breeding', spec, 'Implement me!');
	return spec.fin_breeder;
};

export const states = [
	{state: 'p', disp: 'p',
		substates: [
			{state: 'ÄÄNI', disp: 'ÄÄNI', 
				substates: [
					{state: 'ä',    disp: 'ä',    disables: ['än', 'Än']},
					{state: 'Ä',    disp: 'Ä',    disables: ['än', 'Än']},
					{state: 'än',   disp: 'än',   disables: ['ä', 'Ä']},
					{state: 'Än',   disp: 'Än',   disables: ['ä', 'Ä']},
					{state: 'var',  disp: 'var',  disables: []},
					{state: 'rumm', disp: 'rumm', disables: [], enabler: is_woodpecker},
				]
			},
			{state: 'SUUNTA', disp: 'SUUNTA', 
				substates: [
					{state: 'N',   disp: 'N',   disables: ['NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'NNW', disp: 'NNW', disables: ['N',   'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'NW',  disp: 'NW',  disables: ['N',   'NNW', 'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'WNW', disp: 'WNW', disables: ['N',   'NNW', 'NW',  'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'W',   disp: 'W',   disables: ['N',   'NNW', 'NW',  'WNW', 'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'WSW', disp: 'WSW', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'SW',  disp: 'SW',  disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'SSW', disp: 'SSW', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'S',   disp: 'S',   disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'SSE', disp: 'SSE', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'SE',  disp: 'SE',  disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'ESE', disp: 'ESE', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'E',   disp: 'E',   disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'ENE', disp: 'ENE', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'N',   'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'NE',  disp: 'NE',  disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'N',   'ENE', 'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'NNE', disp: 'NNE', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'N',   'ENE', 'NE',  'N-E', 'S-E', 'S-W', 'N-W']},
				]
			},
			{state: 'SEKTORI', disp: 'SEKTORI', 
				substates: [
					{state: 'N-E', disp: 'N-E', disables: ['S-E', 'S-W', 'N-W', 'N', 'NNW', 'NW', 'WNW', 'W', 'WSW', 'SW', 'SSW', 'S', 'SSE', 'SE', 'ESE', 'E', 'ENE', 'NE', 'NNE']},
					{state: 'S-E', disp: 'S-E', disables: ['N-E', 'S-W', 'N-W', 'N', 'NNW', 'NW', 'WNW', 'W', 'WSW', 'SW', 'SSW', 'S', 'SSE', 'SE', 'ESE', 'E', 'ENE', 'NE', 'NNE']},
					{state: 'S-W', disp: 'S-W', disables: ['N-E', 'S-E', 'N-W', 'N', 'NNW', 'NW', 'WNW', 'W', 'WSW', 'SW', 'SSW', 'S', 'SSE', 'SE', 'ESE', 'E', 'ENE', 'NE', 'NNE']},
					{state: 'N-W', disp: 'N-W', disables: ['N-E', 'S-E', 'S-W', 'N', 'NNW', 'NW', 'WNW', 'W', 'WSW', 'SW', 'SSW', 'S', 'SSE', 'SE', 'ESE', 'E', 'ENE', 'NE', 'NNE']},
				]
			},
			{state: 'REVIIRI', disp: 'REVIIRI',
				substates: [
					{state: 'rev',    disp: 'rev',    disables: ['pysrev']},
					{state: 'pysrev', disp: 'pysrev', disables: ['rev']},
				],
				enabler: is_breeding
			},
			{state: 'RENG', disp: 'RENG',
				substates: [
					{state: 'reng',  disp: 'reng',  disables: ['kontr', 'pyyd']},
					{state: 'kontr', disp: 'kontr', disables: ['reng',  'pyyd']},
					{state: 'pyyd',  disp: 'pyyd',  disables: ['kontr', 'reng']},
				]
			},
			{state: 'lask', disp: 'lask'},
			{state: 'nous', disp: 'nous'},
		]
	},
	{state: 'm', disp: 'm',
		substates: [
			{state: 'SUUNTA', disp: 'SUUNTA', 
				substates: [
					{state: 'N',   disp: 'N',   disables: ['NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'NNW', disp: 'NNW', disables: ['N',   'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'NW',  disp: 'NW',  disables: ['N',   'NNW', 'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'WNW', disp: 'WNW', disables: ['N',   'NNW', 'NW',  'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'W',   disp: 'W',   disables: ['N',   'NNW', 'NW',  'WNW', 'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'WSW', disp: 'WSW', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'SW',  disp: 'SW',  disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'SSW', disp: 'SSW', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'S',   disp: 'S',   disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'SSE', disp: 'SSE', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'SE',  disp: 'SE',  disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'ESE', disp: 'ESE', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'E',   disp: 'E',   disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'ENE', disp: 'ENE', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'N',   'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'NE',  disp: 'NE',  disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'N',   'ENE', 'NNE', 'N-E', 'S-E', 'S-W', 'N-W']},
					{state: 'NNE', disp: 'NNE', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'N',   'ENE', 'NE',  'N-E', 'S-E', 'S-W', 'N-W']},
				]
			},
			{state: 'SEKTORI', disp: 'SEKTORI', 
				substates: [
					{state: 'N-E', disp: 'N-E', disables: ['S-E', 'S-W', 'N-W', 'N', 'NNW', 'NW', 'WNW', 'W', 'WSW', 'SW', 'SSW', 'S', 'SSE', 'SE', 'ESE', 'E', 'ENE', 'NE', 'NNE']},
					{state: 'S-E', disp: 'S-E', disables: ['N-E', 'S-W', 'N-W', 'N', 'NNW', 'NW', 'WNW', 'W', 'WSW', 'SW', 'SSW', 'S', 'SSE', 'SE', 'ESE', 'E', 'ENE', 'NE', 'NNE']},
					{state: 'S-W', disp: 'S-W', disables: ['N-E', 'S-E', 'N-W', 'N', 'NNW', 'NW', 'WNW', 'W', 'WSW', 'SW', 'SSW', 'S', 'SSE', 'SE', 'ESE', 'E', 'ENE', 'NE', 'NNE']},
					{state: 'N-W', disp: 'N-W', disables: ['N-E', 'S-E', 'S-W', 'N', 'NNW', 'NW', 'WNW', 'W', 'WSW', 'SW', 'SSW', 'S', 'SSE', 'SE', 'ESE', 'E', 'ENE', 'NE', 'NNE']},
				]
			},
			{state: 'ÄÄNI', disp: 'ÄÄNI', 
				substates: [
					{state: 'ä',    disp: 'ä',    disables: ['än', 'Än']},
					{state: 'Ä',    disp: 'Ä',    disables: ['än', 'Än']},
					{state: 'än',   disp: 'än',   disables: ['ä', 'Ä']},
					{state: 'Än',   disp: 'Än',   disables: ['ä', 'Ä']},
				]
			},
			{state: 'kiert', disp: 'kiert', disables: ['N-E', 'S-E', 'S-W', 'N-W', 'N', 'NNW', 'NW', 'WNW', 'W', 'WSW', 'SW', 'SSW', 'S', 'SSE', 'SE', 'ESE', 'E', 'ENE', 'NE', 'NNE']},
			{state: 'kontr', disp: 'kontr', disables: ['yöm']},
			{state: 'yöm', disp: 'yöm', disables:['kontr']},
		]
	},
	{state: '?', disp: '?',
		substates: [
			{state: 'kiert', disp: 'kiert', disables: ['N-E', 'S-E', 'S-W', 'N-W', 'N', 'NNW', 'NW', 'WNW', 'W', 'WSW', 'SW', 'SSW', 'S', 'SSE', 'SE', 'ESE', 'E', 'ENE', 'NE', 'NNE', 'kuollut']},
			{state: 'ÄÄNI', disp: 'ÄÄNI', 
				substates: [
					{state: 'ä',    disp: 'ä',    disables: ['än', 'Än', 'kuollut']},
					{state: 'Ä',    disp: 'Ä',    disables: ['än', 'Än', 'kuollut']},
					{state: 'än',   disp: 'än',   disables: ['ä', 'Ä', 'kuollut']},
					{state: 'Än',   disp: 'Än',   disables: ['ä', 'Ä', 'kuollut']},
				]
			},
			{state: 'SUUNTA', disp: 'SUUNTA', 
				substates: [
					{state: 'N',   disp: 'N',   disables: ['NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W', 'kuollut']},
					{state: 'NNW', disp: 'NNW', disables: ['N',   'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W', 'kuollut']},
					{state: 'NW',  disp: 'NW',  disables: ['N',   'NNW', 'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W', 'kuollut']},
					{state: 'WNW', disp: 'WNW', disables: ['N',   'NNW', 'NW',  'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W', 'kuollut']},
					{state: 'W',   disp: 'W',   disables: ['N',   'NNW', 'NW',  'WNW', 'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W', 'kuollut']},
					{state: 'WSW', disp: 'WSW', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W', 'kuollut']},
					{state: 'SW',  disp: 'SW',  disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SSW', 'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W', 'kuollut']},
					{state: 'SSW', disp: 'SSW', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'S',   'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W', 'kuollut']},
					{state: 'S',   disp: 'S',   disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'SSE', 'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W', 'kuollut']},
					{state: 'SSE', disp: 'SSE', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SE',  'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W', 'kuollut']},
					{state: 'SE',  disp: 'SE',  disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'ESE', 'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W', 'kuollut']},
					{state: 'ESE', disp: 'ESE', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'E',   'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W', 'kuollut']},
					{state: 'E',   disp: 'E',   disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'ENE', 'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W', 'kuollut']},
					{state: 'ENE', disp: 'ENE', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'N',   'NE',  'NNE', 'N-E', 'S-E', 'S-W', 'N-W', 'kuollut']},
					{state: 'NE',  disp: 'NE',  disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'N',   'ENE', 'NNE', 'N-E', 'S-E', 'S-W', 'N-W', 'kuollut']},
					{state: 'NNE', disp: 'NNE', disables: ['N',   'NNW', 'NW',  'WNW', 'W',   'WSW', 'SW',  'SSW', 'S',   'SSE', 'SE',  'ESE', 'N',   'ENE', 'NE',  'N-E', 'S-E', 'S-W', 'N-W', 'kuollut']},
				]
			},
			{state: 'SEKTORI', disp: 'SEKTORI', 
				substates: [
					{state: 'N-E', disp: 'N-E', disables: ['S-E', 'S-W', 'N-W', 'N', 'NNW', 'NW', 'WNW', 'W', 'WSW', 'SW', 'SSW', 'S', 'SSE', 'SE', 'ESE', 'E', 'ENE', 'NE', 'NNE', 'kuollut']},
					{state: 'S-E', disp: 'S-E', disables: ['N-E', 'S-W', 'N-W', 'N', 'NNW', 'NW', 'WNW', 'W', 'WSW', 'SW', 'SSW', 'S', 'SSE', 'SE', 'ESE', 'E', 'ENE', 'NE', 'NNE', 'kuollut']},
					{state: 'S-W', disp: 'S-W', disables: ['N-E', 'S-E', 'N-W', 'N', 'NNW', 'NW', 'WNW', 'W', 'WSW', 'SW', 'SSW', 'S', 'SSE', 'SE', 'ESE', 'E', 'ENE', 'NE', 'NNE', 'kuollut']},
					{state: 'N-W', disp: 'N-W', disables: ['N-E', 'S-E', 'S-W', 'N', 'NNW', 'NW', 'WNW', 'W', 'WSW', 'SW', 'SSW', 'S', 'SSE', 'SE', 'ESE', 'E', 'ENE', 'NE', 'NNE', 'kuollut']},
				]
			},
			{state: 'kontr', disp: 'kontr', disables: ['']},
			{state: 'kuollut', disp: 'kuollut', disables: ['N-E', 'S-E', 'S-W', 'N-W', 'N', 'NNW', 'NW', 'WNW', 'W', 'WSW', 'SW', 'SSW', 'S', 'SSE', 'SE', 'ESE', 'E', 'ENE', 'NE', 'NNE', 'kiert', 'än', 'Än', 'ä', 'Ä']},
		]
	},
];

const StyledToggleButton = styled(ToggleButton)`
  &.MuiButtonBase-root {
    color: white;
    background-color: #1976d2;
    &:hover {
      background-color: #166abc;
    }
  }
  &.Mui-selected {
    color: white;

    background-color: #145ea8;
    &:hover {
      background-color: #115293;
    }
  }
`;

//     border-color: black;
let obsState = [];

export function strToState(str) {
	let a = str.split(',');

	for (let i = 0; i < a.length; i++)
		a[i] = a[i].trim();

	return a;
}

export function stateToStr(sa) {
	let str = '';

	/* TODO: sort! */
	sa.sort((s1, s2) => {
		if (s1 === 'lask')
			return -1;
		return 0;
	});

	sa.forEach((s, i) => {
		if (str.length)
			str += ', ';

		str += s;
	});

	return str;
}

export function getBigState(sa, states) {
	let i;

	for (i = 0; i < states.length; i++) {
		if (sa.indexOf(states[i].state) >= 0) {
			return states[i].state;
		}
	}

	return '';
}

const StateWiz2 = observer(forwardRef((props, ref) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function bigStateChange(e, value) {
		console.log('bigStateChange', value, obsState.indexOf(value));

		if (!value || obsState.indexOf(value) >= 0)
			return;

		obsState = [];
		obsState.push(value);

		const str = stateToStr(obsState);
		gStorage.add.setSOState(props.id, str, stateIsValid(str, stateList));
	}

	function getSubstate(s, _sname) {
		let i;

		if (s.state === _sname)
			return s;

		if (!s.substates)
			return null;

		for (i = 0; i < s.substates.length; i++) {
			let ret;

			ret = getSubstate(s.substates[i], _sname);
			if (ret)
				return ret;
		}

		return null;
	}

	function stateChange(e) {
		let bs, s, cs, ss, ind;

		bs = getBigState(obsState, states);
		if (bs === '') {
			console.error('stateChange: no big state!');
			return;
		}

		s = states.find((s) => s.state === bs);
		if (!s) {
			console.error('stateChange: no state for big state', bs, '!');
			return;
		}

		ss = e.target.value;

		cs = getSubstate(s, ss);
		if (!cs) {
			console.error('stateChange: no substate', ss, 'for state', s.state, '!');
			return;
		}

// 		console.log('stateChange: substate', cs);

		ind = obsState.indexOf(cs.state);
		if (ind < 0) {
			if (cs.disables) 
				obsState = obsState.filter((el) => !cs.disables.includes(el));

			obsState.push(cs.state);
		} else {
			obsState.splice(ind, 1);
		}

		const str = stateToStr(obsState);
		gStorage.add.setSOState(props.id, str, stateIsValid(str, stateList));
	}

	function addAvailStates(sa, s) {
		let cl;

		if (s.enabler) {
			let t = typeof(s.enabler);

			if (t === 'function') {
				 if (!s.enabler(gStorage.add.spec)) {
					 return null;
				 }
			} else {
				console.error('stateFileter: unknown disabler type', t);
				return null;
			}
		}

		if (s.substates) {
			return (<optgroup value={s.state} key={s.state} label={s.disp}>
				{s.substates.map((ss) => {
					return addAvailStates(sa, ss);
				})};
				</optgroup>)
		}

		cl = obsState.indexOf(s.state) >= 0 ? '#80cbc4' : 'white';

		return (<option value={s.state} key={s.state} style={{backgroundColor:cl}}>{s.disp}</option>);
	}

	function availStateList() {
		let ret = [<option key={1} value={1} style={{fontWeight: "bold"}}>{gStorage.add.obs.subobs[props.id].sum_desc} </option>];
		
		const bs = getBigState(obsState, states);
		if (bs === '')
			return ret;

		const s = states.find((s) => s.state === bs);

		s.substates.forEach((ss, ind) => {
			ret.push(addAvailStates(ret, ss));
		})

		return ret;
	}

	useImperativeHandle(ref, () => ({
		bigStateChange,
		stateChange
	}));

	if (!gStorage.conn.user.statewiz)
		return null;

	obsState = strToState(gStorage.add.obs.subobs[props.id].sum_desc);

	return (<div>
		<Grid size={{xs: 12}} align={'center'}>
			<ToggleButtonGroup
				size="small"
				value={getBigState(obsState, states)}
				onChange={bigStateChange} 
				exclusive
				style={{margin: 8, marginTop: 4}}
			>
				{states.map((dt, i) => {
					return (
						<StyledToggleButton key={i} value={dt.state} style={{width: 100, textTransform: 'none'}}>
							{dt.disp}
						</StyledToggleButton>);
				})}
			</ToggleButtonGroup>
		</Grid>
		<Grid size={{xs: 12}} align={'center'}>
			<FormControl variant="outlined" size="small">
				<InputLabel>{t('add.state')}</InputLabel>
				<Select
					native
					error={!gStorage.add.obs.subobs[props.id].state_valid}
					disabled={getBigState(obsState, states) === ''}
					value={1}
					onChange={stateChange}
					style={{width: 300, margin: 4}}>
						{availStateList()}
				</Select>
			</FormControl>
		</Grid>
	</div>)
}));

export default StateWiz2;
